<template>
  <div>
    <!-- 搜索框 -->
    <a-card title="App授权">
      <a-button slot="extra" type="primary" @click="handleNewApp">新建</a-button>
      <a-form layout="inline" @submit="handleSubmit" :form="form">
          <a-form-item label="应用编码">
              <AppAutoComplete  ref="appcodeAss" @onAppCodeChange = "handleSearchAppcodeChange"></AppAutoComplete>
          </a-form-item>
         <a-form-item label="所属领域">
            <a-select v-model="searchP.domain"  placeholder=""  style="width:120px">
                <a-select-option value="">
                全部
                </a-select-option>
                 <a-select-option  v-for="(item,index) in domainName" :key="index" :value="index">
                {{item}}
                </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="授权标识">
            <a-select v-model="searchP.authflag"  placeholder="" style="width:120px">
                <a-select-option value="">
                全部
                </a-select-option>
                <a-select-option  v-for="(item,index) in flagname" :key="index" :value="index">
                {{item}}
                </a-select-option>

            </a-select>
          </a-form-item>

          <a-form-item>
              <a-button
                  type="primary"
                  htmlType="submit"
                  :key="this.loading.key"

              >筛选</a-button>
          </a-form-item>
          <a-form-item>
            <a-button
                    type="default"
                    htmlType="submit"
                    :key="this.loading.key"
                    @click="handleSearchReset"
                >重置</a-button>
            </a-form-item>
            <a-tooltip placement="top">
                    <template slot="title">
                    <span>appcode + domain 已存在的记录会被忽略</span>
                    </template>
                <a-upload
                    name="file"
                    :multiple="true"
                    style="float:right;"
                    action="'http://192.168.1.63:9000/data/"
                    :headers="headers"
                    :data="handleImportFile"
                    @change="handleChange"
                >
                <a-button type="primary"  :loading= "isImporting"> <a-icon type="upload" /> 导入 </a-button>
                </a-upload>
            </a-tooltip>
                <a-button
                type="primary"
                style="float:right;margin-right:20px;"
                @click="handleExportService('export_all')"
                :loading= "isExporting"
            >导出全部</a-button>

            <a-button
                type="primary"
                style="float:right;margin-right:20px;"
                @click="handleExportService('export_select')"
                :loading= "isExporting"
            >导出选中</a-button>
      </a-form>
    </a-card>

    <!-- 系统列表 -->
    <a-table :columns="columns" :data-source="data"  :pagination="false" :loading="tLoading" rowKey="id" style="margin-top:20px;" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,type:rowsType}">

        <span slot="domain" slot-scope="text">{{domainName[text]}}</span>
        <span slot="authflag" slot-scope="text">{{flagname[text]}}</span>
        <authedStr slot="authappcodes" slot-scope="text" :authedStr="text"></authedStr>
      <template slot="operation" slot-scope="text, record">
        <div >
         <span>
           <a-button type="link" @click="handle_auth_edit(record)">编辑</a-button>
          </span>
          <span>
            <a-popconfirm  @confirm="() => handle_auth_delete(record)" >
                <template slot="title">
                    <p>{{ '确认将【' + record.appcode+ '】删除？' }}</p>
                </template>
            <a>删除</a>
            </a-popconfirm>
          </span>
        </div>


      </template>
    </a-table>

   <a-pagination class="my_pagenation" v-model="searchP.page" :total="searchP.total" @change="handlePageChange" show-less-items show-quick-jumper />

  </div>
</template>
<script>
import authedStr from "./tableItems";
import AppAutoComplete from '@/components/AppAutoComplete'

const data = [];
const domainName = {
    '001':'前台',
    '002':'中台',
    '003':'开放',
    '004':'基础',

};
const flagname = {
    '0':'不开启',
    '1':'开启白名单',
    '2':'开启黑名单',
};

let searchP={
    appcode:'',
    domain:'',
    authflag:'',
    total:0,
    pageSize:10,
    page:undefined,
};
const columns = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = searchP;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        }
    },
    {
        title: '系统应用编码',
        dataIndex: 'appcode',
        align: 'center',
        width: 120,
    },
    {
        title: '领域',
        dataIndex: 'domain',
        align: 'center',
        scopedSlots: { customRender: 'domain' },
        width: 80,
    },
    {
        title: '授权标识',
        dataIndex: 'authflag',
        align: 'center',
        scopedSlots: { customRender: 'authflag' },
        width: 120,
    },


    {
        title: '授权系统应用',
        dataIndex: 'authappcodes',
        align: 'left',

        scopedSlots: { customRender: 'authappcodes' },
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 120,
        scopedSlots: { customRender: 'operation' },
    }

];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            searchP,
            domainName,
            flagname,
            tLoading:true,
            currentItemList:'',
            selectedRowKeys: [],
            isExporting:false,
            isImporting:false,
            exportId:'',
            importId:'',
            checkStatuesTime:0,
            rowsType:'checkbox',
            datasource:{
                isShow:false,
                authedStr:''
            }, headers: {
                authorization: 'authorization-text',
            },
        };
    },
    methods: {
        handleSearchAppcodeChange(value){
            this.searchP.appcode = value;
        },
        // 分页事件
        handlePageChange(c){
            this.searchP.page = c;
            this.updateRoute()
        },
        updateRoute(){
            this.$router.push({
                query: {
                    appcode:this.searchP.appcode,
                    domain:this.searchP.domain,
                    authflag:this.searchP.authflag,
                    page:this.searchP.page
                }
            });
        },
        getAuthedAppList(){
            let c_params = {
                ...this.searchP
            }

            this.tLoading = true;
            this.$store.dispatch({
                type: "servicekey/getAuthedAppList",
                params:c_params
            }).then((res)=>{
                console.log(res);
                this.tLoading = false;
                let result = res.data.data;
                if(result){
                    this.data = result.list;
                    this.searchP.total = parseInt(result.totalRecords);
                    this.searchP.pageSize = parseInt(result.pageSize);
                    this.searchP.page = parseInt(result.page);
                }
            })
        },
        handle_auth_edit(ritem){
            this.$router.push({
                path: "editapp",
                query: {appcode:ritem.appcode,domain:ritem.domain}
            });
        },
        handle_auth_delete(item){
            this.tLoading = true;
            this.$store.dispatch({
                type: "servicekey/deleteAuthedApp",
                params:{id:item.id,appcode:item.appcode,domain:item.domain,urlparams:false}
            }).then((res)=>{
                console.log(res);
                this.tLoading = false;
                if(res.data.success == '1'){
                    this.getAuthedAppList()
                }
            })
        },
        handleSearchReset(){
            this.searchP.page = 1;
            this.searchP.appcode='';
            this.searchP.domain = '';
            this.searchP.authflag = '';
            this.updateRoute()
        },
        handleNewApp(){
            this.$router.push({
                path: "addapp",
                query: {appcode:'',domain:''}
            });
        },
        handleSubmit(){
            this.searchP.page = 1;
            this.updateRoute()
        },

        onSelectChange(selectedRowKeys){
            this.selectedRowKeys = selectedRowKeys;
        },
        handleExportService(flag){


            let exportIds = this.selectedRowKeys.join(',')
            if(flag == 'export_select'){
                //导出选中
                if(!exportIds){
                    this.message.error('请勾选需要导出的列')
                    return
                }
            }
            else{
                //导出所有
                if(exportIds){
                    this.message.error('导出所有时，请不要选中列')
                    return
                }
            }
            let businesstype = "exportFpAppAuth"
            this.isExporting = true
            this.$store
                .dispatch({
                    type: 'servicekey/exportService',
                    params: {
                        exportbusinesstype:businesstype,
                        exportparamsdesc:'{}',
                        type:this.searchP.type,
                        exportids:exportIds,
                        urlparams:false
                    }
                })
                .then((res) => {
                    if(res.data.success == '1'){
                        console.log(res)
                        this.exportId = res.data.data
                        this.checkExportStatue();

                    }
                    else{
                        this.isExporting = false;
                        this.message.error('导出失败')
                    }
                }).catch((e) => {
                    this.isExporting = false;
                    this.message.error('导出失败'+e.message)
                });
        },

        checkExportStatue(){
            if(this.checkStatuesTime > 3){
                this.message.error('超出请求次数')
                this.checkStatuesTime = 0;
                clearTimeout(this.timer)
                this.isExporting = false
                return;
            }
            let that = this;
            this.timer = setTimeout(function(){
                that.$store
                    .dispatch({
                        type: 'servicekey/checkExportStatue',
                        params: {id:that.exportId}
                    })
                    .then((res) => {
                        if(res.data.success == 1){
                            if(res.data.data.exportstatus == 1){
                                //导出成功
                                that.isExporting = false
                                let temp_File_Str = res.data.data.exportfilefull;
                                let files = temp_File_Str.split(',')
                                for (let index = 0; index < files.length; index++) {
                                    const element = files[index];
                                    window.open(element)
                                }

                            }
                            else{
                                that.checkExportStatue()
                            }
                        }
                        else{
                            that.checkExportStatue()
                        }
                        console.log(res)
                        that.checkStatuesTime++
                    });
            },2000);

        },
        //上传文件结果处理
        handleChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                this.saveImportRecord(info.file.objName,info.file.originFileObj.name);
                this.message.success(`${info.file.name} file uploaded successfully`);

            } else if (info.file.status === 'error') {
                this.message.error(`${info.file.name} file upload failed.`);
            }
        },
        getUniqueCode(){
            const s = [];
            const hexDigits = "0123456789abcdef";
            for (let i = 0; i < 36; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
            }
            s[14] = "4";
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
            s[8] = s[13] = s[18] = s[23] = "-";
            return s.join("");
        },
        getSuffix(filename){
            const pos = filename.lastIndexOf('.');
            let suffix = '';
            if (pos !== -1) {
                suffix = filename.substring(pos)
            }
            return suffix;
        },
        handleImportFile(file){
            // let that = this;
            let result = this.D.syncSelect({
                type:'servicekey/importConfig',
                params:{}
            })
            if (result.success !== '1') {
                // that.message.error(result['errorMsg']);
                return false;
            }
            const data = result.data;
            const {
                dir,
                policy,
                accessid,
                callback,
                signature
            } = data;
            const token = {
                policy: policy,
                OSSAccessKeyId: accessid,
                success_action_status: '200',
                callback: callback,
                signature: signature
            };
            const objName = dir + this.getUniqueCode() + this.getSuffix(file.name);
            file.objName = objName;
            return{
                ...token,
                key: objName
            }

        },

        saveImportRecord(fileUrl,filename){
            let businesstype = "importFpAppAuth"
            this.isImporting = true;
            this.$store
                .dispatch({
                    type: 'servicekey/saveImportService',
                    params: {
                        importbusinesstype:businesstype,
                        shopcode:'125806668',
                        loginuserbranchcode:'1001',
                        sourcefile:fileUrl,
                        filename:filename,
                        syncstatus:1,
                        updownstatus:1,
                        type:this.searchP.type,
                        urlparams:false
                    }
                })
                .then((res) => {
                    if(res.data.success == '1'){
                        console.log(res)
                        this.importId = res.data.data
                        this.checkImportStatue();

                        //刷新页面
                        this.$router.push({
                            path: this.action,
                            query: ''
                        });

                    }
                    else{
                        this.isImporting = false;
                        this.message.error('导入失败')
                    }

                }).catch((e) => {
                    this.isImporting = false;
                    this.message.error('导入失败'+e.message)
                });
        },

        checkImportStatue(){
            if(this.checkStatuesTime > 3){
                this.message.error('超出请求次数')
                this.checkStatuesTime = 0;
                clearTimeout(this.timer)
                this.isImporting = false
                return;
            }
            let that = this;
            this.timer = setTimeout(function(){
                that.$store
                    .dispatch({
                        type: 'servicekey/checkImportStatue',
                        params: {id:that.importId}
                    })
                    .then((res) => {
                        if(res.data.success == 1){
                            if(res.data.data.importstatus == 1){
                            //导入成功
                                that.isImporting = false
                            }
                            else if(res.data.data.importstatus == 2){
                                that.isImporting = false
                                that.message.error(res.data.data.errormsg)
                            }
                            else{
                                that.checkImportStatue()
                            }
                        }
                        else{
                            that.checkImportStatue()
                        }
                        console.log(res)
                        that.checkStatuesTime++
                    });
            },2000);

        },

    },
    computed:{

    },
    watch: {
        '$route' () {
            this.$router.go(0);
        }
    },
    components:{
        authedStr,
        AppAutoComplete
    },
    mounted(){

        let query = this.$route.query;
        this.searchP.appcode = query.appcode ? query.appcode : '';
        this.searchP.page = query.page ? +query.page : 1;
        this.$refs.appcodeAss.setInputVal(this.searchP.appcode);
        this.getAuthedAppList();
    }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
